// Loan additional expenses on the screen.
//
// The amounts are not worked out here: the API prices the chosen expenses
// (GET /api/loans/quote, and the stored loan's GET /api/loans/:id/additional-expenses).
// A form only chooses which expense codes a loan carries.

// The expenses a new loan starts with selected (the API applies the same pair
// when a request names none).
export const DEFAULT_EXPENSE_CODES = ['NAMFISA_LEVY', 'DUTY_STAMP'];

/** How an expense is charged, for display next to its name. */
export function describeExpense(type) {
  if (String(type?.calculation_method) === 'percentage') {
    return `${Number(type?.default_rate_percent || 0)}% of principal`;
  }
  return 'Fixed amount';
}
